/**
 * The browser's console, at ONE address.
 *
 * The repo's rule is "no `console` in production code, use the logger"; the
 * backend's logger is pino and cannot run here, so this is the frontend's
 * equivalent: a single module that owns the suppression, so a reviewer greps
 * `console.` and finds one file instead of a habit spreading screen by screen.
 *
 * It carries `warn` and nothing else, deliberately. The one thing this app has
 * to report from the browser is an ambiance that could not play (immersion
 * spec I9) - a degradation the person must never see and the operator must be
 * able to find. Anything worth more than a warning belongs to an error state
 * on screen, not to a console line nobody reads.
 *
 * **Never pass it a verbatim, a piece of matter or a tester's identity** (PII
 * rule of the pitch). What goes through here names cues and identifiers.
 */
export const logger = {
  warn(message: string, cause?: unknown): void {
    // biome-ignore lint/suspicious/noConsole: this module IS the frontend logger.
    if (cause === undefined) console.warn(message);
    // biome-ignore lint/suspicious/noConsole: this module IS the frontend logger.
    else console.warn(message, cause);
  },
};
